import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
// import { FaAngellist } from 'react-icons/fa';
import { SiUpwork } from 'react-icons/si';

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a
        href="https://www.upwork.com/freelancers/kretsulvitalii"
        target="_blank"
        rel="noreferrer"
      >
        <SiUpwork />
      </a>
      <a
        href="https://www.linkedin.com/in/vitalii-kretsul-442213b6/"
        target="_blank"
        rel="noreferrer"
      >
        <BsLinkedin />
      </a>
      <a
        href="https://github.com/Kretsul-Vitaliy"
        target="_blank"
        rel="noreferrer"
      >
        <FaGithub />
      </a>
      {/* <a
        href="https://angel.co/u/vitalii-kretsul"
        target="_blank"
        rel="noreferrer"
      >
        <FaAngellist />
      </a> */}
    </div>
  );
};

export default HeaderSocials;
